(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-information-blocks"] && !Shopify.designMode) return;
  try {
    const productDescriptionReadMoreHeight = 54;
  const descEl = document.querySelector('.product__block--description');
  const collapsedHeight = productDescriptionReadMoreHeight;
  const threshold = collapsedHeight * 1.175;

  if (descEl && descEl.scrollHeight >= threshold) {
    // prepare element for transition
    descEl.style.maxHeight = collapsedHeight + 'px';
    descEl.style.overflow = 'hidden';
    descEl.style.transition = 'max-height 75ms ease';
    descEl.style.marginBottom = '0';

    // build toggle button
    const toggleBtn = document.createElement('button');
    toggleBtn.className = 'readmore-toggle read-more btn--link';
    toggleBtn.textContent = 'Read more';
    toggleBtn.setAttribute('aria-expanded', 'false');

    descEl.insertAdjacentElement('afterend', toggleBtn);

    toggleBtn.addEventListener('click', (e) => {
      e.preventDefault();

      // expand
      descEl.style.maxHeight = descEl.scrollHeight + 'px';
      descEl.classList.add('readmore-expanded');
      toggleBtn.setAttribute('aria-expanded', 'true');

      // hide button (mimic lessLink: false)
      toggleBtn.style.display = 'none';
    });
  }
  } catch(e) { console.error(e); }
})();

})();
